/* eslint-disable react-hooks/exhaustive-deps */
import { Form, Input } from "antd";
import React, { useMemo, useRef, useState } from "react";
import { useEffect } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { buildPropertyStreetAddress } from "../utils/universalFuntions";
import { useMediaQuery } from "react-responsive";
import { customerDocsContractTypes } from "../commondata/commonData";

const SubjectLine = ({ form, data, source, clientDocs, rootDocData }) => {
  const { addressDetails } = useSelector((state) => state.offerTable);
  const { getIndividualTransactionData } = useSelector((state) => state.rtdTransactionLane);

  const { sharedDocs } = useSelector((state) => state.transactionReport);
  const { propertyDocs, contactDocs } = useSelector((state) => state.createOffer, shallowEqual);
  const { contactSheetData } = useSelector((state) => state.contactSheetReducer);

  const [documentName, setDocumentName] = useState("");
  const inputChanged = useRef(false);

  const isClientDoc = customerDocsContractTypes.includes(rootDocData?.contractType);

  const addressObj = source === "CONTACT_SHEET" ? contactSheetData?.addressDetails : getIndividualTransactionData?.addressDetails;

  let streetAddress = useMemo(() => buildPropertyStreetAddress(addressObj), [addressObj]);
  if (["SHARE_OMD", "SEND_EMAIL_BUYER_AGENT", "SHARE_INDIVIDUAL_OFFER", "SELLING_RTD"].includes(source)) {
    streetAddress = addressDetails?.StreetAddress || "";
  }

  const breakPoint = useMediaQuery({ maxWidth: "573px" });
  const getDocumentNames = (docNames, selectedDocArray, dataArray, tab) => {
    for (let i = 0; i < selectedDocArray?.length; i++) {
      for (let j = 0; j < dataArray?.length; j++) {
        if (tab?.length) {
          if (tab === "SHARED" && selectedDocArray[i] === dataArray[j]?._id) {
            docNames.push({
              updatedName: dataArray[j]?.updatedName || null,
              name: dataArray[j]?.fileName,
            });
          } else if (tab === "CLIENTS" && selectedDocArray[i].documentId === dataArray[j]?._id) {
            docNames.push({
              updatedName: dataArray[j]?.updatedName || null,
              name: dataArray[j]?.contractName,
            });
          } else if (tab === "CUSTOMERS") {
            if (selectedDocArray[i] === dataArray[j]?._id) {
              docNames.push({
                updatedName: dataArray[j]?.updatedName || null,
                name: dataArray[j]?.documentName,
              });
            }
            dataArray?.[j]?.matchedDocuments?.forEach((ele)=>{
              if (selectedDocArray[i] === ele?._id) {
                docNames.push({
                  updatedName: dataArray[j]?.updatedName || null,
                  name: dataArray[j]?.documentName,
                });
              }
            })
          } else if (dataArray[j]?.contractId && selectedDocArray[i] === dataArray[j]?.documentId) {
            docNames.push({
              updatedName: dataArray[j]?.updatedName || null,
              name: dataArray[j]?.documentName,
            });
          } else if (selectedDocArray[i] === dataArray[j]?._id) {
            docNames.push({
              updatedName: dataArray[j]?.updatedName || null,
              name: dataArray[j]?.fileName,
            });
          }
        } else if (dataArray[j]?.documentId && selectedDocArray[i] === dataArray[j]?.documentId) {
          docNames.push({
            updatedName: dataArray[j]?.updatedName || null,
            name: dataArray[j]?.documentName,
          });
        } else if (selectedDocArray[i] === dataArray[j]?._id) {
          docNames.push({
            updatedName: dataArray[j]?.updatedName || null,
            name: dataArray[j]?.fileName,
          });
        }
      }
    }
  };

  useEffect(() => {
    if (!inputChanged.current) {
      const docNamesArray = [];
      if (data?.propertyDocsSelected?.length) getDocumentNames(docNamesArray, data.propertyDocsSelected, propertyDocs);
      if (data?.sharedSelected?.length) getDocumentNames(docNamesArray, data.sharedSelected, sharedDocs, "SHARED");
      if (data?.documentWithoutBuyerSelected?.length) getDocumentNames(docNamesArray, data.documentWithoutBuyerSelected, propertyDocs, "WithoutBuyers");
      if (isClientDoc && data?.clientDocumentSelected?.length) getDocumentNames(docNamesArray, data.clientDocumentSelected, clientDocs, "CLIENTS");
      if (docNamesArray.length) {
        const doc = docNamesArray[0];
        const baseName = doc.docCreatedCount > 1 ? `${doc.name?.trim()}_${doc.docCreatedCount - 1}` : doc.name?.trim();
        let finalName = "";
        if (isClientDoc) {
          if (docNamesArray.length === 1) {
            finalName = doc.updatedName ? `${doc.updatedName.trim()}` : baseName;
          } else {
            finalName = "Document Links";
          }
        } else {
          if (docNamesArray.length === 1) {
            finalName = doc.updatedName ? `${doc.updatedName.trim()} (${doc.name?.trim()})` : baseName;
          } else {
            finalName = "Document Links";
          }
        }
        setDocumentName(finalName);
      } else {
        setDocumentName("");
      }
    }
  }, [data, contactDocs, propertyDocs, sharedDocs, clientDocs, isClientDoc]);

  // console.log("documentName", documentName);
  useEffect(() => {
    let subject = "";
    if (getIndividualTransactionData?.transactionType === "BUILDER" && getIndividualTransactionData?.projectName) {
      subject = getIndividualTransactionData?.projectName + ": " + (documentName ? `${documentName}` : "");
    } else if (source === "SEND_EMAIL_BUYER_AGENT") {
      subject = (streetAddress ? streetAddress + ": " : "") + "Offer Update";
    } else if (source === "SHARE_INDIVIDUAL_OFFER") {
      subject = (streetAddress ? streetAddress + ": " : "") + "Offer";
    } else if (source === "SHARE_OMD") {
      subject = (streetAddress ? streetAddress + ": " : "") + "Offers";
    } else if (isClientDoc) {
      subject = documentName || "";
    } else {
      subject = [streetAddress, documentName].filter(Boolean).join(": ");
    }
    form.setFieldsValue({
      subject: subject,
    });
  }, [documentName, streetAddress, isClientDoc, source]);

  return (
    <Form form={form} labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
      <Form.Item label={<span style={{ fontWeight: "bold", color: "grey", fontSize: breakPoint ? "14px" : "18px" }}>Subject</span>} name="subject">
        <Input onChange={() => (inputChanged.current = true)} />
      </Form.Item>
    </Form>
  );
};

export default SubjectLine;
